import { createMuiTheme } from '@material-ui/core';

export const vooptyTheme = createMuiTheme({
  typography: {
    fontSize: 14,
  },
  palette: {
    primary: {
      light: '#fbfbfb',
      main: '#FDAA2D',
      dark: '#1e2024',
      contrastText: '#fff',
    },
    secondary: {
      light: '#595959',
      main: '#1e2024',
      dark: '#1e2024',
      attention: '#ba000d',
      contrastText: '#fff',
    },
  },
  zIndex: { drawer: 1040 },
  width: { sectionWidth: 1360 },
  textDecoration: { Link: 'none', a: 'none' },
  overrides: {
    MuiLink: {
      root: {
        color: '#337ab7',
      },
    },

    MUIDataTable: {
      responsiveScroll: {
        maxHeight: undefined,
      },
    },
    MuiDivider: {
      light: {
        backgroundColor: '#fff',
      },
    },
    MuiTableCell: {
      root: {
        paddingLeft: '4px',
        paddingRight: '4px',
      },
    },
    MUIDataTableSelectCell: {
      root: {
        '@media (max-width: 959.95px)': {
          display: 'table-cell',
        },
      },
    },
  },
});
